import { useInfiniteQuery, useQuery } from 'react-query'

import { api } from '../../../api'
import { type AssetAnalystDomain } from '../../../../types/domain/asset-analyst-domain'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import { getQueryStrinfied } from '../../../../utils/query'
import { getValidFilters } from '../../../../utils/filters'

export const fetchAssetAnalysts = async (filters: FiltersDomain) => {
  const query = getQueryStrinfied(getValidFilters(filters))
  const response = await api.get<PaginationDomain<AssetAnalystDomain>>(
    `/asset-analysts?${query}`
  )

  return response.data
}

export const useAssetAnalystsQuery = (filters: FiltersDomain) => {
  return useQuery(
    ['asset-analysts', filters],
    () => fetchAssetAnalysts(filters),
    { staleTime: 1000 * 60 * 60 * 1, keepPreviousData: true } // 1 hour
  )
}

export const useInfiniteAssetAnalystsQuery = (filters: FiltersDomain) => {
  return useInfiniteQuery(
    ['asset-analysts', filters],
    ({ pageParam = 1 }) => fetchAssetAnalysts({ ...filters, page: pageParam }),
    {
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
      getNextPageParam ({ meta }) {
        return meta.hasNextPage ? meta.page + 1 : undefined
      },
    }
  )
}
